export default __webpack_public_path__ + "static/media/grid_no_active.e2b80b75.svg";